/**
 * @author Harshitha.k
 * @description 
 */

import moment from 'moment';
import { message } from 'antd';
import { API_DASHBOARD } from '../../../commons/api';
import localStorage from '../../../utils/localStorage';

export async function selectDashboard(Name) {
  let siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;

  let data = await fetch(`${API_DASHBOARD.GET}?SiteId=${siteId}&Name=${Name}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: Authorization
    }
  })
    .then((response) => {
      return response.json();
    })
    .then((response) => {
      if (response.message) {
        message.warning(response.message);
      } else if (Array.isArray(response)) {
        return response;
      }
    })
    .catch((error) => {
      console.log(error);
    });
  return data === undefined ? [] : data;
}

export async function getDashboardByName(e) {
  let siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;

  let data = await fetch(`${API_DASHBOARD.GET}?SiteId=${siteId}&Name=${e}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: Authorization
    }
  })
    .then((response) => {
      return response.json();
    })
    .then((json) => {
      if (json) {
        return json;
      }
    })
    .catch((error) => {
      console.log(error);
    });
  return data === undefined ? [] : data;
}

export async function updateDashboard(panelData, dashboardName, dashboardId, GroupName,headerJson
) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  let data = await fetch(`${API_DASHBOARD.UPDATE}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: Authorization
    },
    body: JSON.stringify({
      Name: dashboardName,
      Id: dashboardId,
      GroupName,
      json: panelData,
      headerJSON: headerJson,
      ModifiedBy: 1,
      ModifiedDate: moment().format('YYYY-MM-DD HH:mm:ss'),
      SiteId: siteId
    })
  })
    .then((response) => {
      return response.json();
    })
    .then((json) => {
      if (json.message) {
        return json.message;
      }
    })
    .catch(() => {
      //return [];
    });
  return data === undefined ? '' : data;
}

export async function insertDashboard(panelData, dashboardName, dashboardId, GroupName,headerJson
) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;

  let data = await fetch(`${API_DASHBOARD.CREATE}`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      Authorization: Authorization
    },
    body: JSON.stringify({
      Name: dashboardName,
      Id: dashboardId,
      json: panelData,
      headerJSON: headerJson,
      GroupName,
      CreatedBy: 1,
      CreatedDate: moment().format('YYYY-MM-DD HH:mm:ss'),
      SiteId: siteId,
      Status: 'Active'
    })
  })
    .then((response) => {
      return response.json();
    })
    .then((json) => {
      if (json.message) {
        return json.message;
      }
    })
    .catch(() => { });

  return data === undefined ? [] : data;
}

export async function deleteDashboard(Id) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;

  let data = await fetch(`${API_DASHBOARD.DELETE}?SiteId=${siteId}&Id=${Id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: Authorization
    }
  })
    .then((response) => {
      return response.json();
    })
    .then((json) => {
      if (json.Data) {
        return json.Data;
      } else if (json.message) {
        return json.message;
      }
    })
    .catch(() => {
      // return [];
    });

  return data === undefined ? [] : data;
}
